export enum Env {
    trial = "trial",
    epic = "epic",
    mba = "mba",
    mgtdsStudent = "student.mgtds",
    mgtdsInstructor = "instructor.mgtds",
    nanci = "nanci",
    lafon = "lafon",
    sales = "sales"
}
